import urlManager from './urlManager';

Array.from(document.querySelectorAll('.filter-button')).forEach(function(filterButton) {

    filterButton.onclick = function() {
  
      let key = filterButton.getAttribute('data-filter');
  
      urlManager.updateAndGo("filter[" + key +"]", null);
  
      return false;
    }
  
  });
  Array.from(document.querySelectorAll('.toggle-filter-options-button')).forEach(function(filterToggleButton) {
  
    filterToggleButton.onclick = function() {
  
      document.body.classList.toggle('filter-options--reveal');
  
      return false;
    }
  
  });